import type { QueryExportMemberRequestArgs } from '@tribeplatform/gql-client/types'
import type { ExportFields } from '@tribeplatform/gql-client/types/generated'

import { KeyConstructor } from './keyConstructor.js'

const EXPORT_REQUEST_KEY = 'exportRequest'

export const getExportRequestKey = KeyConstructor<
  QueryExportMemberRequestArgs,
  ExportFields
>(EXPORT_REQUEST_KEY)
